// Test Interface JavaScript

// Test configuration

let TEST_SECTIONS = {
    english: { name: 'English', questions: 0, options: ['A','B','C','D','F','G','H','J'] },
    math:    { name: 'Math',    questions: 0, options: ['A','B','C','D','F','G','H','J'] },
    reading: { name: 'Reading', questions: 0, options: ['A','B','C','D','F','G','H','J'] }
};

// Option sets
const OPTIONS_ABCD = ['A','B','C','D'];
const OPTIONS_FGHJ = ['F','G','H','J'];

// Legacy alias so any old code that referenced QUESTION_OPTIONS keeps working
const QUESTION_OPTIONS = { ABCD: OPTIONS_ABCD, FGHJ: OPTIONS_FGHJ };

// Global state
let currentTest = null;
let currentSection = 'english';
let studentAnswers = {
    english: {},
    math: {},
    reading: {}
};
let userData = null;
let testId = null;
let autoSaveTimeout = null;

let QUESTION_OPTION_MAP ={
    english:{},
    math:{},
    reading:{}
}

// after TEST_SECTIONS is declared
const SECTION_META = TEST_SECTIONS; 

function getQuestionOptions(section, qNum) {
  const fam = (QUESTION_OPTION_MAP[section] || {})[qNum];
  return fam === 'FGHJ' ? OPTIONS_FGHJ : OPTIONS_ABCD; // default to ABCD
}


document.addEventListener('DOMContentLoaded', async () => {
  try {
    userData = getUserSession();
    if (!userData) return (window.location.href = 'index.html');

    // Update sidebar user name
    const sidebarUserElement = document.getElementById('sidebarUserName');
    if (sidebarUserElement) {
        sidebarUserElement.textContent = userData.full_name;
    }

    const urlParams = new URLSearchParams(window.location.search);
    testId = urlParams.get('testId');
    if (!testId) {
      showMessage('No test selected', 'error');
      return setTimeout(() => (window.location.href = '/pages/act-dashboard'), 2000);
    }

    showLoading('Loading test...');
    await loadTest();                     // sets SECTION_META.*.questions
    await loadAnswerKeyOptionFamilies();  // sets QUESTION_OPTIONS[section][q]
    await loadSavedAnswers();

    renderAnswerSheet();
    setupEventListeners();
    updateProgress();
    
    // Show instructions modal on first load
    showInstructionsModal();
  } catch (err) {
    console.error('Error initializing test:', err);
    showMessage('Failed to load test', 'error');
  } finally {
    hideLoading();
  }
});

// Load test configuration
async function loadTest() {
    try {
        showLoading('Loading test...');

        // get all tests
        const response = await SheetsAPI.getTestConfig();
        console.log('[getTestConfig in test.js]', response);

        if (!response || response.success === false) {
            throw new Error(response?.message || 'Could not load test config');
        }

        const allTests = response.tests || [];
        const thisTest = allTests.find(t =>
            (t.test_id || t.id || t.testId) == testId
        );

        if (!thisTest) {
            throw new Error('Test not found for id ' + testId);
        }

        currentTest = thisTest;

        // 1. Update page title
        document.getElementById('testTitle').textContent =
            currentTest.test_name || currentTest.name || 'ACT Practice Test';

        // 2. Update section question counts dynamically
        TEST_SECTIONS.english.questions = Number(currentTest.english_questions) || 0;
        TEST_SECTIONS.math.questions    = Number(currentTest.math_questions)    || 0;
        TEST_SECTIONS.reading.questions = Number(currentTest.reading_questions) || 0;

        // 3. Also update your section tab labels immediately (e.g. (0/50))
        document.querySelector('[data-section="english"] .tab-count').textContent =
          `(0/${TEST_SECTIONS.english.questions})`;

        document.querySelector('[data-section="math"] .tab-count').textContent =
          `(0/${TEST_SECTIONS.math.questions})`;

        document.querySelector('[data-section="reading"] .tab-count').textContent =
          `(0/${TEST_SECTIONS.reading.questions})`;

        hideLoading();
    } catch (error) {
        console.error('Error loading test:', error);
        hideLoading();
        showMessage('Failed to load test details', 'error');
        throw error;
    }
}

async function loadAnswerKeyOptionFamilies() {
  const res = await SheetsAPI.getAnswerKeys(testId);

  const map = { english: {}, math: {}, reading: {} };

  if (res?.success && Array.isArray(res.answer_keys)) {
    for (const row of res.answer_keys) {
      const sec = String(row.section || '').toLowerCase();   // 'english'|'math'|'reading'
      if (!map.hasOwnProperty(sec)) continue;

      const qn  = Number(row.question_number);
      if (!Number.isFinite(qn) || qn <= 0) continue;

      // We ignore is_scored here on purpose – unscored questions still get shown
      const ans = String(row.correct_answer || '').trim().toUpperCase();

      // store the family token
      map[sec][qn] = ['F','G','H','J'].includes(ans) ? 'FGHJ' : 'ABCD';
    }
  }

  QUESTION_OPTION_MAP = map;  // e.g., {english:{1:'ABCD',2:'FGHJ',...}, ...}
}


// Load saved answers from Student_Responses sheet
async function loadSavedAnswers() {
    try {
        const response = await sheetsAPI.getStudentResponses({
            uid: userData.uid,
            test_id: testId
        });
        
        if (response.success && response.data) {
            // Parse saved answers
            const savedData = response.data;
            
            if (savedData.english_answers) {
                studentAnswers.english = JSON.parse(savedData.english_answers || '{}');
            }
            if (savedData.math_answers) {
                studentAnswers.math = JSON.parse(savedData.math_answers || '{}');
            }
            if (savedData.reading_answers) {
                studentAnswers.reading = JSON.parse(savedData.reading_answers || '{}');
            }

            console.log('Loaded saved answers:', studentAnswers);
        }
    } catch (error) {
        console.error('Error loading saved answers:', error);
        // Continue with empty answers if load fails
    }
}


// Render answer sheet for all sections
function renderAnswerSheet() {
  const answerSheet = document.getElementById('answerSheet');
  answerSheet.innerHTML = '';

  // build the section tabs' counts using SECTION_META
    document.querySelectorAll('.section-tab').forEach(tab => {
    const sec = tab.dataset.section;
    const total    = Number(TEST_SECTIONS[sec]?.questions || 0);
    const answered = Object.keys(studentAnswers[sec] || {}).length;
    const span = tab.querySelector('.tab-count');
    if (span) span.textContent = `(${answered}/${total})`;
    });

  // sections in order
  ['english','math','reading'].forEach(sectionKey => {
    const totalQ = SECTION_META[sectionKey]?.questions || 0;
    if (totalQ <= 0) return;  

    const sectionDiv = document.createElement('div');
    sectionDiv.className = `section-grid ${sectionKey === currentSection ? 'active' : ''}`;
    sectionDiv.dataset.section = sectionKey;

    const titleDiv = document.createElement('div');
    titleDiv.className = 'section-title';
    titleDiv.textContent = `${TEST_SECTIONS[sectionKey].name} (${TEST_SECTIONS[sectionKey].questions} Questions)`;
    sectionDiv.appendChild(titleDiv);

    const questionsGrid = document.createElement('div');
    questionsGrid.className = 'questions-grid';

    for (let qn = 1; qn <= totalQ; qn++) {
    const options = getQuestionOptions(sectionKey, qn); // ← picks ABCD or FGHJ
    const item = createQuestionItem(sectionKey, qn, options);
    questionsGrid.appendChild(item);
    }


    sectionDiv.appendChild(questionsGrid);
    answerSheet.appendChild(sectionDiv);
  });

  updateNavigationButtons();
  updateProgress();
}


// Create a single question item with bubbles
function createQuestionItem(section, questionNum, options) {
  const item = document.createElement('div');
  item.className = 'question-item';
  item.dataset.section = section;
  item.dataset.question = questionNum;

  // Use the options array we were given, otherwise derive it now
  const optSet = Array.isArray(options) ? options : getQuestionOptions(section, questionNum);

  if (studentAnswers[section][questionNum]) {
    item.classList.add('answered');
  }

  const numberDiv = document.createElement('div');
  numberDiv.className = 'question-number';
  numberDiv.textContent = `${questionNum}.`;
  item.appendChild(numberDiv);

  const optionsDiv = document.createElement('div');
  optionsDiv.className = 'bubble-options';

  optSet.forEach(option => {
    const bubble = document.createElement('button');
    bubble.className = 'bubble';
    bubble.textContent = option;
    bubble.dataset.option = option;

    if (studentAnswers[section][questionNum] === option) {
      bubble.classList.add('selected');
    }

    bubble.addEventListener('click', () => {
      handleAnswerSelect(section, questionNum, option, item);
    });

    optionsDiv.appendChild(bubble);
  });

  item.appendChild(optionsDiv);
  return item;
}


// Handle answer selection with unselect feature
function handleAnswerSelect(section, questionNum, option, questionItem) {
  // Check if clicking the same option - if so, unselect it
  if (studentAnswers[section][questionNum] === option) {
    // Unselect the answer
    delete studentAnswers[section][questionNum];
    
    const bubbles = questionItem.querySelectorAll('.bubble');
    bubbles.forEach(bubble => {
      bubble.classList.remove('selected');
    });
    
    questionItem.classList.remove('answered');
  } else {
    // Select the new answer
    studentAnswers[section][questionNum] = option;

    const bubbles = questionItem.querySelectorAll('.bubble');
    bubbles.forEach(bubble => {
      bubble.classList.toggle('selected', bubble.dataset.option === option);
    });

    questionItem.classList.add('answered');
  }
  
  updateProgress();
  scheduleAutoSave();
}


// Get total answered
function getTotalAnswered() {
    return Object.values(studentAnswers).reduce((sum, section) => sum + Object.keys(section).length, 0);
}

// Update progress indicators
function updateProgress() {
  const totalAnswered =
    Object.keys(studentAnswers.english).length +
    Object.keys(studentAnswers.math).length +
    Object.keys(studentAnswers.reading).length;

  const totalQuestions =
    TEST_SECTIONS.english.questions +
    TEST_SECTIONS.math.questions +
    TEST_SECTIONS.reading.questions;

  // progress bar + text
  const pct = totalQuestions ? (totalAnswered / totalQuestions) * 100 : 0;
  document.getElementById('progressFill').style.width = `${pct}%`;
  document.getElementById('progressText').textContent =
    `${totalAnswered} of ${totalQuestions} answered`;

  // tab counters
  ['english','math','reading'].forEach(s => {
    const answered = Object.keys(studentAnswers[s]).length;
    const total    = TEST_SECTIONS[s].questions;
    const tab = document.querySelector(`.section-tab[data-section="${s}"]`);
    if (tab) {
      tab.querySelector('.tab-count').textContent = `(${answered}/${total})`;
      tab.classList.toggle('completed', answered === total);
    }
  });

  // submit-visibility rule
  updateSubmitButtonVisibility();
}

// Update submit button visibility
function updateSubmitButtonVisibility() {
    const submitBtn = document.getElementById('submitTestBtn');
    if (!submitBtn) return;
    
    const totalAnswered =
        Object.keys(studentAnswers.english).length +
        Object.keys(studentAnswers.math).length +
        Object.keys(studentAnswers.reading).length;
    
    // Show submit button when on reading section and any questions are attempted
    if (currentSection === 'reading' && totalAnswered > 0) {
        submitBtn.style.display = 'block';
    } else {
        submitBtn.style.display = 'none';
    }
}

// Schedule auto-save
function scheduleAutoSave() {
    // Clear existing timeout
    if (autoSaveTimeout) {
        clearTimeout(autoSaveTimeout);
    }

    // Set new timeout (save after 2 seconds of inactivity)
    autoSaveTimeout = setTimeout(() => {
        saveAnswers();
    }, 2000);
}

// Save answers to Google Sheets
async function saveAnswers(showIndicator = true) {
    try {
        if (showIndicator) {
            showAutoSaveIndicator('saving');
        }

        const data = {
            uid: userData.uid,
            test_id: testId,
            english_answers: JSON.stringify(studentAnswers.english),
            math_answers: JSON.stringify(studentAnswers.math),
            reading_answers: JSON.stringify(studentAnswers.reading),
            status: 'in_progress',
            last_section: currentSection
        };

        const response = await sheetsAPI.saveStudentResponses(data);

        if (response.success) {
            if (showIndicator) {
                showAutoSaveIndicator('saved');
                setTimeout(() => hideAutoSaveIndicator(), 2000);
            }
        } else {
            console.error('Save failed:', response.error);
        }
    } catch (error) {
        console.error('Error saving answers:', error);
    }
}

// Auto-save indicator
function showAutoSaveIndicator(status) {
    let indicator = document.querySelector('.autosave-indicator');
    if (!indicator) {
        indicator = document.createElement('div');
        indicator.className = 'autosave-indicator';
        document.body.appendChild(indicator);
    }

    indicator.className = `autosave-indicator ${status}`;
    indicator.textContent = status === 'saving' ? 'Saving...' : 'Saved';
}

function hideAutoSaveIndicator() {
    const indicator = document.querySelector('.autosave-indicator');
    if (indicator) {
        indicator.style.display = 'none';
    }
}

// Instructions Modal Functions
function showInstructionsModal() {
    const modal = document.getElementById('instructionsModal');
    modal.classList.add('active');
}

function hideInstructionsModal() {
    const modal = document.getElementById('instructionsModal');
    modal.classList.remove('active');
}

// Set up event listeners
function setupEventListeners() {
    // Section tabs
    document.querySelectorAll('.section-tab').forEach(tab => {
        tab.addEventListener('click', () => {
            const section = tab.dataset.section;
            switchSection(section);
        });
    });

    // Instructions button
    document.getElementById('instructionsBtn').addEventListener('click', () => {
        showInstructionsModal();
    });

    // Close instructions button
    document.getElementById('closeInstructionsBtn').addEventListener('click', () => {
        hideInstructionsModal();
    });

    // Save & Exit button
    document.getElementById('saveExitBtn').addEventListener('click', async () => {
        await saveAnswers(false);
        showMessage('Progress saved!', 'success');
        setTimeout(() => window.location.href = 'dashboard.html', 1000);
    });

    // Submit Test button
    document.getElementById('submitTestBtn').addEventListener('click', () => {
        showSubmitModal();
    });

    // Modal buttons
    document.getElementById('cancelSubmitBtn').addEventListener('click', () => {
        hideSubmitModal();
    });

    document.getElementById('confirmSubmitBtn').addEventListener('click', () => {
        submitTest();
    });

    // Navigation buttons
    document.getElementById('nextSectionBtn').addEventListener('click', () => {
        navigateSection('next');
    });

    document.getElementById('prevSectionBtn').addEventListener('click', () => {
        navigateSection('prev');
    });

    // Close modals on background click
    document.getElementById('instructionsModal').addEventListener('click', (e) => {
        if (e.target.id === 'instructionsModal') {
            hideInstructionsModal();
        }
    });

    document.getElementById('submitModal').addEventListener('click', (e) => {
        if (e.target.id === 'submitModal') {
            hideSubmitModal();
        }
    });
}

// Switch section
function switchSection(section) {
    currentSection = section;

    // Update tabs
    document.querySelectorAll('.section-tab').forEach(tab => {
        tab.classList.toggle('active', tab.dataset.section === section);
    });

    // Update section grids
    document.querySelectorAll('.section-grid').forEach(grid => {
        grid.classList.toggle('active', grid.dataset.section === section);
    });

    // Update current section display
    document.getElementById('currentSection').textContent = TEST_SECTIONS[section].name;

    // Update navigation buttons
    updateNavigationButtons();
    
    // Update submit button visibility
    updateSubmitButtonVisibility();
}

// Navigate between sections
function navigateSection(direction) {
    const sections = Object.keys(TEST_SECTIONS);
    const currentIndex = sections.indexOf(currentSection);

    if (direction === 'next' && currentIndex < sections.length - 1) {
        switchSection(sections[currentIndex + 1]);
    } else if (direction === 'prev' && currentIndex > 0) {
        switchSection(sections[currentIndex - 1]);
    }
}

// Update navigation buttons visibility
function updateNavigationButtons() {
    const sections = Object.keys(TEST_SECTIONS);
    const currentIndex = sections.indexOf(currentSection);

    const prevBtn = document.getElementById('prevSectionBtn');
    const nextBtn = document.getElementById('nextSectionBtn');

    // Show/hide previous button
    prevBtn.style.display = currentIndex > 0 ? 'block' : 'none';

    // Show/hide next button
    nextBtn.style.display = currentIndex < sections.length - 1 ? 'block' : 'none';
}

// Show submit modal
function showSubmitModal() {
    const modal = document.getElementById('submitModal');
    const summary = document.getElementById('submitSummary');

    // Generate summary
    let summaryHTML = '';
    Object.keys(TEST_SECTIONS).forEach(sectionKey => {
        const section = TEST_SECTIONS[sectionKey];
        const answered = Object.keys(studentAnswers[sectionKey]).length;
        summaryHTML += `<p><strong>${section.name}:</strong> ${answered}/${section.questions} answered</p>`;
    });

    const total = getTotalAnswered();
    const totalQuestions = TEST_SECTIONS.english.questions + 
                          TEST_SECTIONS.math.questions + 
                          TEST_SECTIONS.reading.questions;
    summaryHTML += `<p style="margin-top: 15px; font-size: 16px;"><strong>Total:</strong> ${total}/${totalQuestions} answered</p>`;

    summary.innerHTML = summaryHTML;
    modal.classList.add('active');
}

// Hide submit modal
function hideSubmitModal() {
    const modal = document.getElementById('submitModal');
    modal.classList.remove('active');
}

// Submit test for grading
async function submitTest() {
  try {
    showLoading('Submitting test...');
    hideSubmitModal();

    const payload = {
      uid: userData.uid,
      test_id: testId,
      english_answers: JSON.stringify(studentAnswers.english),
      math_answers: JSON.stringify(studentAnswers.math),
      reading_answers: JSON.stringify(studentAnswers.reading),
      status: 'submitted',
      submitted_at: new Date().toISOString()
    };

    const response = await SheetsAPI.saveStudentResponses(payload);

    if (response.success) {
      // 👉 NEW: also save locally for analysis UI
      const attempt = buildLocalAttempt(testId, studentAnswers);
      const all = JSON.parse(localStorage.getItem('act_attempts') || '{}');
      all[testId] = attempt;
      localStorage.setItem('act_attempts', JSON.stringify(all));

      // Show success message
      showMessage('Test submitted successfully! Redirecting to analysis...', 'success');
      
      // Update loading text
      showLoading('Test submitted! Loading analysis...');
      
      // Add a small delay to ensure backend is fully updated
      setTimeout(() => {
        window.location.href = '/pages/act-analysis?testId=' + testId;
      }, 1500);
    } else {
      hideLoading();
      throw new Error(response.error || 'Failed to submit test');
    }
  } catch (err) {
    hideLoading();
    console.error(err);
    alert(err.message);
  }
}

function buildLocalAttempt(testId, studentAnswers) {

  const sectionTotals = { english: 50, math: 45, reading: 36 };
  return {
    testId,
    status: 'submitted',
    submittedAt: new Date().toISOString(),
    answers: {
      english: studentAnswers.english,
      math: studentAnswers.math,
      reading: studentAnswers.reading
    },
    meta: {
      totals: sectionTotals
    }
  };
}


// Loading overlay
function showLoading(text = 'Loading...') {
    let overlay = document.querySelector('.loading-overlay');
    if (!overlay) {
        overlay = document.createElement('div');
        overlay.className = 'loading-overlay';
        overlay.innerHTML = `
            <div class="loading-spinner"></div>
            <div class="loading-text">${text}</div>
        `;
        document.body.appendChild(overlay);
    } else {
        const textEl = overlay.querySelector('.loading-text');
        if (textEl) textEl.textContent = text;
        overlay.style.display = 'flex';
    }
}

function hideLoading() {
    const overlay = document.querySelector('.loading-overlay');
    if (overlay) {
        overlay.style.display = 'none';
    }
}




// Initialize navigation buttons on load
updateNavigationButtons();